<template>
  <div>
    <v-dialog persistent max-width="500" v-model="dialogVisible">
      <v-card elevation="1" flat class="rounded-lg pa-5">
        <div>
          <h1
            style="
              font-size: 28px;
              font-style: normal;
              font-weight: 700;
              line-height: 39px;
              letter-spacing: 0em;
              text-align: center;
              padding: 25px 30px;
            "
          >
            Authentication Email Sent
          </h1>

          <p
            style="
              margin-top: 10px;
              margin-bottom: 30px;
              font-size: 20px;
              font-style: normal;
              font-weight: 400;
              line-height: 27px;
              letter-spacing: 0em;
              text-align: center;
              color: #a5b3bf;
            "
          >
            Authentication link has been sent.
            <br />
            Please check your email to continue.
          </p>

          <div class="pa-12 pt-5">
            <v-btn
              id="submit"
              block
              height="50"
              color="primary"
              class="mr-4 text-capitalize font-weight-bold"
              @click="closeDialog"
            >
              Ok
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "@/lib/api";
import localstorage from '@/lib/localstorage'
import Vue from 'vue'

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    async closeDialog() {
      const cid = localStorage.getItem("cid");
      const userId = localStorage.getItem("uid");
      const payload = {
        cid: cid,
        user_id: userId
      };

      const token = Vue.cookie ? Vue.cookie.get('access_token') : localstorage.getItem("token");
      if (!token) {
        this.$store.dispatch(
          "HOMEPAGE/showErrorToast",
          "Authentication token not found. Please try logging in again.",
          { root: true }
        );
        return;
      }

      try {
      const res = await api.POST("/user/auth/send-login-url", payload);
        
      if (res.code === 200) {
        // Hanya hapus state sesi yang memang harus di-invalidate selama menunggu
        // verifikasi lewat email. Sebelumnya di sini dipanggil localstorage.clear()
        // lalu sebagian key di-set ulang satu per satu, sehingga key yang tidak ikut
        // di-restore (uid, is_creator, dan privilages/superadmin_privileges yang
        // saling meniadakan karena if/else) hilang dan membuat banyak halaman rusak
        // setelah login lewat magic link.
        localstorage.removeItem("token");
        localstorage.removeItem("need_validate");
        localstorage.removeItem("timestamp");
        this.$emit("input", false);
          setTimeout(() => {
        window.location.href = "/";
          }, 3000);
      } else {
          this.$store.dispatch(
            "HOMEPAGE/showErrorToast",
            res.data?.message || "Failed to send login URL",
            { root: true }
          );
        }
      } catch (error) {
        let errorMessage = "Failed to send login URL";
        if (error?.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error?.response?.data?.data) {
          errorMessage = error.response.data.data;
        } else if (error?.message) {
          errorMessage = error.message;
        }
        this.$store.dispatch(
          "HOMEPAGE/showErrorToast",
          errorMessage,
          { root: true }
        );
      }
    }
  }
};
</script>
